import type { UsageEvent } from "../types/usage";
import { apiBase, getAuthHeaders, handleJson } from "./http";

export const userApi = {
  async listUsageEvents(params?: {
    start_at?: number;
    end_at?: number;
    limit?: number;
    offset?: number;
  }): Promise<UsageEvent[]> {
    const query = new URLSearchParams();
    if (params?.start_at != null) query.set("start_at", String(params.start_at));
    if (params?.end_at != null) query.set("end_at", String(params.end_at));
    if (params?.limit != null) query.set("limit", String(params.limit));
    if (params?.offset != null) query.set("offset", String(params.offset));
    const qs = query.toString();
    const response = await fetch(
      `${apiBase}/usage/events${qs ? `?${qs}` : ""}`,
      {
        credentials: "include",
        headers: getAuthHeaders(),
      }
    );
    return handleJson<UsageEvent[]>(response);
  },
};
